import { Component, Input } from '@angular/core';
import { BaseProperties } from '@com-delta-idp/mnx-ui-kit';
import {
  CreditSummary,
  CreditSummaryStyles
} from '../../pages/fast-action-banner-page/models/credit-summary.interfaces';

@Component({
  selector: 'idp-offer-credit-banner',
  templateUrl: './offer-credit-banner.component.html',
  styleUrls: ['./offer-credit-banner.component.scss']
})
export class OfferCreditBannerComponent
  implements
    BaseProperties<
      Record<string, string | number | boolean | { [key: string]: string }>,
      CreditSummary,
      CreditSummaryStyles
    >
{
  @Input() content: CreditSummary | undefined = {} as CreditSummary;
  @Input() styles: CreditSummaryStyles = {} as CreditSummaryStyles;

  WHITE_COLOR = '#ffffff';

  getColor(style: string): string {
    const position = style.indexOf('#');

    return style.substring(position);
  }
}
